<div class="menubar-hoverable header-fixed menubar-pin"
  style="font-family: 'Roboto', sans-serif, Helvetica, Arial, sans-serif;font-size: 13px;line-height: 1.846153846;color: #313534;background-color: #ffffff;">
  <!-- BEGIN BASE-->
  <div id="base">
    <div class="offcanvas">
    </div>
    <div id="content">
      <div class="main-container-expense-report">
        <div class="page-name-academic-selection">
          <div class="page-name">
            <div class="report-text">{{ string.report }}</div>
            <div class="expense-heading">{{string.expenseReport}}</div>
          </div>
          <div class="export-button">
            <button class="export-btn" (click)="showDialog()"><i class="ri-download-2-line"></i> {{string.export}}</button>
          </div>
        </div>
        <div class="academic-year-selection">
          <div class="heading-academic-year-selection">
            {{string.chooseAcademicYear}}
          </div>
          <select class="academic-year-selection-box" [(ngModel)]="selectedAcademicYear"
            (change)="changeAcademicYear()">
            <option *ngFor="let key of academicYears" [ngValue]="key">
              {{ key.Year }} <span *ngIf="key.isCurrentAcademic"> ({{string.currentYear}})</span>
            </option>
          </select>
        </div>
        <div [ngClass]="{
        'filter-info' : !isFilterOpen,
        'filter-info-open' : isFilterOpen
       }">
          <div class="filter-sub-container">
            <div class="filter-container">
              <div class="filter-by-heading"> {{string.filterBy}}</div>
              <div class="payee-type">
                <div class="label-expense">{{string.payeeType}}</div>
                <div class="label-expense-value">{{appliedPayeeType!=="All"? (appliedPayeeType.length===payeeType.length
                  ? string.all :appliedPayeeType.length + string.selected) : string.all}} </div>
              </div>
              <div class="payee-type">
                <div class="label-expense">{{string.payeeName}}</div>
                <div class="label-expense-value">
                  {{appliedPayeeName!=="All"? (appliedPayeeName.length===payeeName.length ? "All"
                  :appliedPayeeName.length + string.selected) : string.all}}
                </div>
              </div>
              <div class="payee-type">
                <div class="label-expense">{{string.paymentMethod}}</div>
                <div class="label-expense-value"> {{appliedPaymentMethod!=="All"?
                  (appliedPaymentMethod.length===paymentMethods.length ? "All" :appliedPaymentMethod.length + string.selected) : string.all}}
                </div>
              </div>
              <div class="payee-type">
                <div class="label-expense">{{string.paymentDate}}</div>
                <div class="label-expense-value">{{startDate===endDate ? startDate : startDate +" to " + endDate}}</div>
              </div>
            </div>
            <div class="more-filter-btn">
              <button *ngIf="isFilterApplied" class="reset-button" (click)="resetFilter()">Reset</button>
              <button (click)="expandView()">
                {{!isFilterOpen ? string.moreFilter : string.lessFilter}}
              </button>
            </div>
          </div>
          <div class="selection-container-filter">
            <div class="selection-box-expense-data">
              <div class="label-expense-data">{{string.payeeType}}</div>
              <div class="input-for-selection-expense">
                <p-multiSelect [options]="payeeType" [(ngModel)]="selectedPayeeType" optionLabel="payeeType"
                  display="comma" [maxSelectedLabels]="0" [selectedItemsLabel]="customSelectionLabel" placeholder="None"
                  (onChange)="updateTypeSelectionLabel()" />
              </div>
            </div>
            <div class="selection-box-expense-data">
              <div class="label-expense-data">{{string.payeeName}}</div>
              <div class="input-for-selection-expense">
                <p-multiSelect [options]="payeeName" [(ngModel)]="selectedPayeeName" optionLabel="payeeName"
                  display="comma" [maxSelectedLabels]="0" [selectedItemsLabel]="customSelectionLabelForPayeeName"
                  placeholder="None" (onChange)="updateSelectionPayeeNameLabel()" />
              </div>
            </div>
            <div class="selection-box-expense-data">
              <div class="label-expense-data">{{string.paymentMethod}}</div>
              <div class="input-for-selection-expense">
                <p-multiSelect [options]="paymentMethods" [(ngModel)]="selectedPaymentMethods"
                  optionLabel="paymentMethod" display="comma" [maxSelectedLabels]="0"
                  [selectedItemsLabel]="customSelectionLabelForPaymentMethodName"
                  (onChange)="updateSelectionPaymentMethodLabel()" placeholder="None" />
              </div>
            </div>
            <div class="selection-box-expense-data">
              <div class="label-expense-data">{{string.paymentDate}}</div>
              <div class="input-for-selection-expense">
                <input ngxDaterangepickerMd class="date-selection-input" [readOnly]="true" autoApply="true"
                  linkedCalendars="true" [locale]="locale" [minDate]="selectedAcademicYear.academicStartDate"
                  [maxDate]="selectedAcademicYear.academicEndDate"
                  showCustomRangeLabel="true" [ranges]="ranges" [placeholder]="startDate === endDate ? startDate : startDate + ' to ' + endDate"
                  [(ngModel)]="selected" [value]="startDate === endDate ? startDate : startDate + ' to ' + endDate" (rangeClicked)="rangeClicked($event)" (datesUpdated)="datesUpdated($event)" />
              </div>
            </div>
          </div>
          <div class="apply-button-filter">
            <div>{{totalRecords}} {{string.resultAvailable}}</div>
            <button (click)="applyFilter()">{{string.apply}}</button>
          </div>
        </div>
        <div class="stat-expense-data">
          <ng-container *ngIf="!fetchingStatData">
            <div *ngFor="let key of statData" class="stat-expense-data-value">
              <div class="stat-name-expense">{{key.statKey}}</div>
              <div class="stat-data-expense" [title]='generateText(key.statValue)'>{{schoolCurrencySymbol}}
                {{formatNumber(key.statValue)}}</div>
            </div>
          </ng-container>
          <ng-container *ngIf="fetchingStatData">
            <div *ngFor="let key of generateDummyArray(4)" class="stat-expense-data-value">
              <p-skeleton width="12rem" height="6rem" />
            </div>
          </ng-container>
        </div>
        <div class="expense-management-table">
          <table class="main-container-table">
            <thead class="expense-table-header">
              <tr *ngIf="expenseColumnData && expenseColumnData.length > 0">
                <ng-container *ngFor="let column of expenseColumnData; let i = index">
                  <th *ngIf="column.isDefault == 1">
                    <div class="selected-first-row-category" (click)="expandExpenseColumnOption(i)">
                      <span>{{ column.columnName }}</span>
                      <span>
                        <img class="row-dropdown-category" src="../../assets/img/row-dropdown.png" alt="arrow" />
                      </span>
                    </div>
                    <div class="option-for-first-row" *ngIf="expenseColumnIndex === i">
                      <div class="option-for-first-row-data" *ngFor="let option of expenseColumnData">
                        <span>
                          <input type="checkbox" (click)="updateExpenseTableColumn(column.slug, option.slug)"
                            id="expense-column-name-{{ option.slug }}" [disabled]="option.isDefault == 1"
                            [checked]="option.isDefault == 1" />
                        </span>
                        <label class="slug-labels" for="expense-column-name-{{ option.slug }}">{{ option.columnName
                          }}</label>
                      </div>
                    </div>
                  </th>
                </ng-container>
              </tr>
            </thead>
            <tbody *ngIf="!fetchingTable" (click)="collapseExpenseColumnOption()" class="expense-table-body">
              <ng-container *ngIf="expenseRowData && expenseRowData.length > 0; else noDataFound">
                <ng-container *ngFor="let row of expenseRowData">
                  <tr>
                    <ng-container *ngFor="let col of expenseColumnData">
                      <td *ngIf="col.isDefault === 1">
                        {{ (col.columnName === 'Total before tax' || col.columnName === 'Total tax' || col.columnName
                        === 'Total after tax')
                        ? (row[col.columnName] > 0 ? schoolCurrencySymbol : '') + formatNumber(row[col.columnName])
                        : row[col.columnName]
                        }} </td>
                    </ng-container>
                  </tr>
                </ng-container>
              </ng-container>
              <ng-template #noDataFound>
                <tr>
                  <td class="text-center" [attr.colspan]="expenseColumnData.length">{{string.noDataAvailable}}</td>
                </tr>
              </ng-template>
            </tbody>
            <tbody *ngIf="fetchingTable" class="expense-table-body">
              <tr class="loader-data" *ngFor="let key of generateDummyArray(10)">
                <td *ngFor="let key of generateDummyArray(6)"><p-skeleton /></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="pagination">
          <div class="data-length-selection">
            {{string.showResult}}
            <select [(ngModel)]="selectedLimit" (change)="changePageLimit()">
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="30">30</option>
              <option value="40">40</option>
              <option value="50">50</option>
            </select>
          </div>
          <p-paginator (onPageChange)="onPageChange($event)" [first]="startingPageNumber" [rows]="selectedLimit"
            [totalRecords]="totalRecords" />
        </div>
      </div>
    </div>

    <p-dialog [header]="string?.export" [modal]="true" [(visible)]="openExportPopUp"
      [style]="{ width: '50rem', fontSize: '16px' }">
      <div class="message-for-export-container">
        <span class="message-for-export">{{string.messageFirst}}</span>
        <span class="message-for-export">{{string.messageSecond}}</span>
      </div>
      <input class="input-for-export-expense-report" [(ngModel)]="emailIds" #emailInput
        [placeholder]="string.provideEmail" />
      <div class="button-export-container">
        <button [disabled]="sendingReport" (click)="exportExpenseReportData()">
          <app-button-loader *ngIf="sendingReport"></app-button-loader>
          <span *ngIf="!sendingReport">{{string.export}}</span>
        </button>
      </div>
    </p-dialog>
  </div>